import { motion, useInView } from "framer-motion"
import { Link, graphql, useStaticQuery } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import ImageOpt from "./ImageOpt"

const CollectionListing = ({ module }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade2 = {
    hidden: { opacity: 0, y: 40 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.75,
        staggerChildren: 0.4,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])
  const data = useStaticQuery(graphql/* GraphQL */ `
    query BarQuery {
      allWpBarCategory(sort: { id: ASC }, filter: { slug: { ne: "shop" } }) {
        edges {
          node {
            id
            link
            name
            slug
          }
        }
      }
      allWpEatDrink(
        filter: {
          barCategory: { nodes: { elemMatch: { slug: { ne: "shop" } } } }
          slug: { nin: ["the-marly", "the-alphen"] }
        }
        sort: { title: ASC }
      ) {
        nodes {
          title
          excerpt
          parentId
          uri
          featuredImage {
            node {
              altText
              mediaItemUrl
            }
          }
          restaurantContent {
            location
            bookNow {
              target
              title
              url
            }
          }
          barCategory {
            nodes {
              name
              slug
              id
            }
          }
        }
      }
    }
  `)

  const categories = data.allWpBarCategory.edges
  const allBarData = data.allWpEatDrink.nodes

  const [tabDetails, setTabDetails] = useState(allBarData)
  const [tabOption, setTabOption] = useState("all")

  useEffect(() => {
    if (tabOption !== "all") {
      const arrayData = []
      for (var i = 0; i < allBarData.length; i++) {
        for (var j = 0; j < allBarData[i].barCategory.nodes.length; j++) {
          if (allBarData[i].barCategory.nodes[j].name === tabOption) {
            arrayData.push(allBarData[i])
          }
        }
      }
      setTabDetails(arrayData)
    } else {
      setTabDetails(allBarData)
    }
  }, [tabOption, allBarData])

  const handleSelectChange = event => {
    setTabOption(event.target.value)
  }

  if (module.hideSection === "no") {
    return (
      <section className="bg-white-100">
        <motion.div
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`category-listing  pt-70 pb-120 lgscreen:pt-35 lgscreen:pb-60${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className="category-anim"
          >
            <motion.div variants={animFade}>
              <ul className="tabs w-full flex flex-wrap justify-center gap-x-8 gap-y-5 smscreen2:hidden">
                <li
                  onClick={() => {
                    setTabOption("all")
                  }}
                  className={`tab-link cursor-pointer text-18 tracking-05em uppercase opacity-50  ${
                    tabOption === "all" ? "tab-current" : ""
                  }`}
                  onKeyDown={() => {
                    setTabOption("all")
                  }}
                  aria-hidden="true"
                >
                  All
                </li>

                {categories.map((item, i) => {
                  return (
                    <li
                      key={i}
                      onClick={() => {
                        setTabOption(item.node.name)
                      }}
                      className={`tab-link cursor-pointer text-18 tracking-05em uppercase opacity-50  ${
                        tabOption === item.node.name ? "tab-current" : ""
                      }`}
                      onKeyDown={() => {
                        setTabOption(item.node.name)
                      }}
                      aria-hidden="true"
                    >
                      {item.node.name}
                    </li>
                  )
                })}
              </ul>
            </motion.div>
            <div className="mobileDropdown hidden smscreen2:block w-[310px] mx-auto relative">
              <img
                className="absolute right-0 top-[10px]"
                src="https://kove.fluxfullcircle.com/app/uploads/2023/09/Vector-34.svg"
                alt=""
              />
              <select
                value={tabOption}
                onChange={handleSelectChange}
                className="border-b-1 border-charcoal w-full pb-5 !outline-none !bg-none !appearance-none"
              >
                <option value="all">All Restaurants & Bars...</option>
                {categories.map((item, i) => {
                  return (
                    <option key={i} value={item.node.name}>
                      {item.node.name}
                    </option>
                  )
                })}
              </select>
            </div>
            <div className="container-fluid">
              <div className="accordian-container">
                <div className="tab-content">
                  <div className="flex flex-wrap mt-50 lgscreen:mt-30 -mx-20 lgscreen:mx-0 gap-y-[120px] lgscreen:gap-y-[50px] mdscreen:gap-y-[25px]">
                    {tabDetails.length > 0 &&
                      tabDetails.map((item, i) => {
                        return (
                          item.parentId === null && (
                            <div
                              className="lg:w-4/12 w-full px-20 lgscreen:px-0"
                              key={i}
                            >
                              <motion.div
                                variants={animFade2}
                                className="category-bx"
                              >
                                {item?.featuredImage && (
                                  <Link to={item.uri}>
                                    {item?.featuredImage && (
                                      <div className="img relative">
                                        <ImageOpt
                                          imgData={
                                            item.featuredImage.node.mediaItemUrl
                                          }
                                          width={1000}
                                          height={800}
                                          imgAlt={
                                            item.featuredImage.node.altText
                                          }
                                          imgLoad="lazy"
                                        />
                                      </div>
                                    )}
                                  </Link>
                                )}

                                <div className="category-content pt-25">
                                  {item?.title && <h4>{item.title}</h4>}
                                  {item?.restaurantContent?.location && (
                                    <div className="flex flex-wrap gap-x-[5px] py-10">
                                      <img
                                        src="../images/location-black.svg"
                                        width={12}
                                        height={12}
                                        loading="lazy"
                                        alt="Location"
                                      />
                                      <span className="font-ositalic text-13">
                                        {item.restaurantContent.location}
                                      </span>
                                    </div>
                                  )}
                                  {item?.excerpt && (
                                    <div className="content w-full pr-30">
                                      {parse(item.excerpt)}
                                    </div>
                                  )}
                                  <div className="flex flex-wrap gap-x-2 gap-y-2 mt-25">
                                    {item?.restaurantContent?.bookNow && (
                                      <Link
                                        to={item.restaurantContent.bookNow.url}
                                        className="btn btn-black"
                                        target={
                                          item.restaurantContent.bookNow.target
                                        }
                                      >
                                        {item.restaurantContent.bookNow.title}
                                      </Link>
                                    )}

                                    <Link
                                      to={item.uri}
                                      className="btn btn-border"
                                    >
                                      explore
                                    </Link>
                                  </div>
                                </div>
                              </motion.div>
                            </div>
                          )
                        )
                      })}
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </section>
    )
  }
  return null
}

export default CollectionListing
export const PageCollectionListingFragment = graphql`
  fragment PageCollectionListingFragment on WpPage_Pagecontent_PageContent_CollectionListing {
    extraId
    extraClass
    hideSection
  }
`
